import { createApp } from 'vue'
import App from './App.vue'
import './App.css' // スタイル読み込み

import axios from 'axios'
window.axios = axios

// window.liff はHTMLで<script>タグで読み込む想定（public/index.htmlなど）
createApp(App).mount('#app')
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker-moon.js')
      .then(() => console.log('Service Worker registered'))
      .catch(error => console.error('Service Worker registration failed:', error));
  });
}

